module.exports = __webpack_public_path__ + "img/avatar.2ffce598.png";